<template>
  <div>
    <a-modal :title="title" v-model="visible" :footer="null" class="save-success-model">
      <div class="save-success-image">
        <img src="@/assets/image/chenggong.png" alt="成功" class="image">
      </div>
      <div class="save-success-text">
        <span>{{ typeTitle }}链接：</span>
        <span>{{ htmlurl }}</span>
        <span style="margin-top: 15px">是否要复制链接发送给对方？</span>
      </div>
      <div class="save-success-button" v-if="visible">
        <a-button type="primary border-arc" v-clipboard="htmlurl" @click="btnCopy">复制链接</a-button>
      </div>
    </a-modal>
    <a-modal :title="title1" v-model="visible1" :footer="null" class="save-success-model" @cancel="cancel">
      <div class="save-success-image">
        <img src="@/assets/image/chenggong.png" alt="成功" class="image">
      </div>
      <div class="save-success-text">
        您是否需要打印此单
      </div>
      <div class="save-success-button1">
        <a-row>
          <a-col>
            <a-button>开始打印</a-button>
          </a-col>
          <a-col>
            <a-button>打印预览</a-button>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <a-button @click="btnPrintPreview">自定义编辑</a-button>
          </a-col>
          <a-col>
            <a-button @click="cancel">退出</a-button>
          </a-col>
        </a-row>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Vue from "vue";
import Clipboard from "v-clipboard";
Vue.use(Clipboard);
export default {
  name: "saveSuccess",
  data() {
    return {
      title: "保存成功",
      visible: false,
      htmlurl: "",
      title1: "提交成功",
      visible1: false,
      typeTitle: "销售报价单",
    };
  },
  methods: {
    show(url, typeTitle) {
      this.htmlurl = url;
      console.log(typeTitle)
      if (typeTitle) {
        this.typeTitle = typeTitle;
      }
      this.visible = true;
    },
    btnCopy() {
      this.$message.success("复制链接成功");
    },
    open() {
      this.visible1 = true;
    },
    btnPrintPreview() {
      this.$emit("onCancelPrint");
      this.visible1 = false;
      setTimeout(() => {
        this.$router.push({ path: "/printmanagement/printset/printPage" });
      }, 50);
    },
    cancel() {
      this.$emit("onCancelPrint");
      this.visible1 = false;
    },
  },
};
</script>
<style lang="scss">
.save-success-model {
  width: 600px !important;
  .ant-modal-content {
    height: 396px;
  }
  .save-success-image {
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    .image {
      width: 70px;
      height: 70px;
    }
  }
  .save-success-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 25px;
  }
  .save-success-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 48px;
  }
  .save-success-button1 {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
    .ant-row {
      .ant-col {
        padding: 0 10px 20px 10px;
      }
    }
  }
}
</style>
